<template>
   <div class="ticker-wrapper">
        <div class="ticker">
            <div class="ticker__item">Flu, Pneumonia and RSV immunizations are available
              by walk-in or appointment. Call to schedule Shingles and COVID vaccinations.
              If you have a respiratory infection, we ask that you use one of the masks
              provided in the entryway to prevent transmission to other patients with
              serious health problems who may be sharing the waiting room with you.
            </div>
        </div>
   </div>
</template>
<script>
export default {
  name: 'Ticker'
}
</script>

<!-- Add CSS here -->
<style scoped>
.ticker {
    box-sizing: content-box;
    color:#ffffff;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;
    padding-left: 100%;
    white-space: nowrap;

    -webkit-animation-iteration-count: infinite;
            animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
            animation-timing-function: linear;
    -webkit-animation-name: ticker;
            animation-name: ticker;
    -webkit-animation-duration: 50s;
            animation-duration: 50s;
}
.ticker-wrapper {
    background-color:#c71104;
    height: 3rem;
    /* position: fixed; */
    overflow: hidden;
    top: 0;
    width: 100%
}

@-webkit-keyframes ticker {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes ticker {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
</style>